module.exports = __webpack_public_path__ + "img/coral-data.d9826c1b.png";